import { IconProps } from "./";
import Icon from "./assets/home_24_bold.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24HomeBold(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
